import React from "react";
import ReactDOM from "react-dom";
import { v4 } from "uuid";
import moment from "moment";
import qs from "qs";
import { Grid } from "@material-ui/core";
import { GetApp as Download } from "@material-ui/icons";
import { MonetaryAmount } from "../../../app/domain/monetary-amount";
import {
  findEmployeeDetail,
  findEmployeeDetailSnapshot,
} from "../../../infrastructure/employees-cache";
import { findEmployeeAdjustments } from "../../../infrastructure/repository/adjustment-repository";
import { findCardEmployee } from "../../../infrastructure/repository/card-repository";
import {
  findCompanyId,
  findCompanyDetail,
} from "../../../infrastructure/repository/company-repository";
import { findModels } from "../../../infrastructure/repository/benefit-models-repository";
import { EmployeeDetailsConsumption } from "../components/EmployeeDetailsConsumption/EmployeeDetailsConsumption";
import { downloadEmployeeAdjustment } from "../download-employee-adjustment";
import SectionContentWrapper from "../../../app/components/SectionContentWrapper";
import { translate as t } from "../../../infrastructure/translate/localization";

export function renderEmployeeConsumptions(props) {
  ReactDOM.render(
    <Grid className="section employee-details-page" container>
      <SectionContentWrapper
        title={t("my-account-section.consumption-month")}
        buttons={[
          {
            icon: <Download />,
            label: t("employees-section.download-consumptions"),
            action: async () => {
              await downloadEmployeeAdjustment(props.employee);
            },
          },
        ]}
      >
        <EmployeeDetailsConsumption {...props} key={v4()} />
      </SectionContentWrapper>
    </Grid>,
    document.getElementById("page-container")
  );
}

export async function displayEmployeeCurrentMonthPurchases({
  employeeId,
  company,
  detailAdjustments,
  card,
  employee,
  error,
  models,
  saveState = "none",
  location = window.location,
}) {
  if (!company) {
    const { data: companyDetail } = await findCompanyDetail();
    company = companyDetail;
  }

  const companyId = findCompanyId();

  if (!models) {
    const { data: benefitModels } = await findModels();
    models = models || benefitModels;
  }

  if (employee) {
    employeeId = employee.id;
  }
  if (!employee) {
    const query = qs.parse(location?.search, { ignoreQueryPrefix: true });
    if (query?.snapshot === "true") {
      employee = await findEmployeeDetailSnapshot({ companyId, employeeId });
    } else {
      employee = await findEmployeeDetail({ companyId, employeeId });
    }
  }

  const employeeIsMoved = employee?.state === "moved";

  if (!detailAdjustments && !employeeIsMoved) {
    const { data: adjustments } = await findEmployeeAdjustments({
      companyId,
      employeeId,
    });

    detailAdjustments = adjustments;
  }

  if (!card && !employeeIsMoved) {
    const { data: cardDetail } = await findCardEmployee({
      companyId,
      employeeId,
    });
    card = cardDetail;
  }

  const {
    formatAdjustments,
    formatRecurrent,
    formatPending,
    adjustmentsCsvString,
  } = detailAdjustments;

  const defaultAmount = {
    amountInCents: 0,
    currency: "EUR",
  };

  let amountHistoryAccumulated = MonetaryAmount.ZERO;
  const totalAccumulated = card?.totalAccumulated || defaultAmount;
  amountHistoryAccumulated = amountHistoryAccumulated.add(
    MonetaryAmount.ofCurrency(totalAccumulated)
  );

  let amountHistoryFunds = MonetaryAmount.ZERO;
  const totalFunds = card?.totalFunds || defaultAmount;
  amountHistoryFunds = amountHistoryFunds.add(
    MonetaryAmount.ofCurrency(totalFunds)
  );

  const props = {
    lastPayrollCloseFormatted: moment(company.lastPayrollCloseIsoTime).format(
      "DD-MM-YYYY"
    ),
    autoCloseDay: company.autoCloseDay,
    employee,
    card,
    adjustments: formatAdjustments?.[0],
    recurrents: formatRecurrent,
    pendings: formatPending,
    adjustmentsCsvString,
    models,
    amountHistoryAccumulated,
    amountHistoryFunds,
    saveState,
    error,
    company,
    detailAdjustments,
    country: company.countryISO2Code,
  };

  renderEmployeeConsumptions(props);

  return null;
}
